import "./style.css";

export default function Footer(){
  return(
    <div className="footer">
      <div className="footer-container">
        <p>&copy; Mentoria Beleza Lucrativa - Todos os direitos reservados.</p>
      </div>
    </div>
  );
};